<footer class="wrapper">
    <div class="footer-wrapper">
        <app-footer-brand-copyright></app-footer-brand-copyright>
        <app-footer-language-translator></app-footer-language-translator>
        <app-footer-brand-socials></app-footer-brand-socials>
    </div>
</footer>
